import React from 'react';
import { useMediaQuery } from 'react-responsive';

import Badge, { BadgeProps } from '../Badge';
import TextWithCheckboxListItemsBlock, {
  TextWithCheckboxListItemsBlockProps,
} from '../TextWithCheckboxListItemsBlock';

import styles from './index.module.scss';

export interface BackgroundImageCardProps {
  imageMobile: string;
  imageDesktop: string;
  badge?: BadgeProps;
  card: TextWithCheckboxListItemsBlockProps;
}

const BackgroundImageCard: React.FC<BackgroundImageCardProps> = ({
  badge,
  card,
  imageMobile,
  imageDesktop,
}) => {
  const isDesktop = useMediaQuery({
    query: '(min-width: 900px)',
  });
  const backgroundImage = isDesktop ? imageDesktop : imageMobile;

  return (
    <div className={styles.wrapper}>
      <img src={backgroundImage} alt={card.title} className={styles.image} />
      {badge && <Badge className={styles.badge} {...badge} />}
      <div className={styles.card}>
        <TextWithCheckboxListItemsBlock {...card} />
      </div>
    </div>
  );
};

export default BackgroundImageCard;
